export enum CardActionType {
  Phone = 'Phone',
  Email = 'Email',
  Google = 'Google',
}

// 卡片操作项接口
export interface CardActionItem {
  icon: string
  title: string
  actionType: CardActionType
}